<template>
  <div class="wrapper">
    <h1
      class="headline mb-6"
    >{{coachType == 'club' ? 'Select your club' : 'Select your highschool'}}</h1>

    <v-text-field
      label="Search"
      solo
      :hide-details="true"
      class="searchInput flex-grow-0 mb-8"
      @input="search"
      v-model="searchInput"
      autocomplete="off"
    ></v-text-field>

    <v-simple-table
      class="mb-8 table align-self-center"
      dense
      v-if="!loading && itemsToShow.length > 0"
    >
      <template>
        <thead>
          <tr>
            <th>Name</th>
            <th v-if="coachType == 'highSchool'">City</th>
            <th v-if="coachType == 'highSchool'">State</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in itemsToShow" :key="index">
            <td>{{ item.name }}</td>
            <td v-if="coachType == 'highSchool'">{{ item.city }}</td>
            <td v-if="coachType == 'highSchool'">{{ item.state }}</td>
            <td>
              <v-btn x-small color="primary" depressed @click="select(item)">Select</v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>

    <div class="mt-6 body-1" v-if="!loading && itemsToShow.length == 0">
      Your
      {{coachType == 'club' ? 'team' : 'high school'}}
      does not exist, please send an email to
      <a
        href="mailto:bobby@playersdirectory.com"
      >bobby@playersdirectory.com</a>
      and we will add it to the directory.
    </div>

    <v-progress-circular
      v-if="loading"
      class="d-block mx-auto mt-12"
      :size="50"
      :width="4"
      indeterminate
      color="primary"
    ></v-progress-circular>

    <v-btn
      large
      color="primary"
      @click="loadMore"
      v-if="searchInput == '' && !loading"
      :loading="loadMoreLoading"
      :disabled="loading"
    >LOAD MORE</v-btn>
  </div>
</template>

<script>
import { db } from "@/db";
import { mapState, mapMutations } from "vuex";
import { debounce } from "throttle-debounce";
import store from "@/store";

export default {
  data() {
    return {
      searchInput: "",
      items: [],
      autoCompleteItems: [],
      loading: false,
      last: null,
      loadMoreLoading: false,
    };
  },
  computed: {
    ...mapState({
      coachType: (state) => state.coachType,
    }),
    itemsToShow() {
      if (this.loading) return [];
      if (this.searchInput == "") return this.items;
      return this.autoCompleteItems;
    },
  },
  created() {
    this.loading = true;
    db.collection(this.coachType == "club" ? "clubTeams" : "highSchools")
      .limit(30)
      .orderBy("searchName")
      .get()
      .then((res) => {
        this.loading = false;
        this.items = res.docs.map((doc) => {
          return { id: doc.id, ...doc.data() };
        });
        this.last = res.docs[res.docs.length - 1];
      });
  },
  methods: {
    ...mapMutations(["setClubOrHighschool"]),
    search: debounce(700, true, function () {
      this.loading = true;
      const start = this.searchInput.toLowerCase();
      const end = start + "\uf8ff";
      db.collection(this.coachType == "club" ? "clubTeams" : "highSchools")
        .orderBy("searchName")
        .startAt(start)
        .endAt(end)
        .limit(30)
        .get()
        .then((res) => {
          this.loading = false;
          this.autoCompleteItems = res.docs.map((doc) => {
            return { id: doc.id, ...doc.data() };
          });
        });
    }),
    loadMore() {
      this.loadMoreLoading = true;
      db.collection(this.coachType == "club" ? "clubTeams" : "highSchools")
        .orderBy("searchName")
        .startAfter(this.last)
        .limit(30)
        .get()
        .then((res) => {
          this.loadMoreLoading = false;
          if (res.empty) {
            alert("no more items to load");
          } else {
            this.last = res.docs[res.docs.length - 1];
            const moreItems = res.docs.map((doc) => {
              return { id: doc.id, ...doc.data() };
            });
            this.items = [...this.items, ...moreItems];
          }
        });
    },
    select(item) {
      this.setClubOrHighschool(item);
      this.$router.push("/third");
    },
  },
  beforeRouteEnter(to, from, next) {
    if (store.state.coachType && store.state.coachInfo) {
      next();
    } else {
      next("/");
    }
  },
};
</script>


<style lang="scss" scoped>
.table {
  min-width: 668px;

  @media screen and (max-width: 708px) {
    min-width: auto;
  }
}
</style>